module.exports = {"apiUrl":"https://shadow-tech-dreamjob-api.be.shadowtechllc.net","brandId":"dreamjob"};